import { css } from '@emotion/react'

import { Spinner } from '@core/assets/Spinner'

import { IconSpan, LabelSpan, StyledSpan } from './Button.styles'
import type { BaseButtonProps } from './types'

/**
 *
 */
export const ButtonContent: React.FC<
  React.PropsWithChildren<BaseButtonProps>
> = (props) => {
  const icon = props.isLoading ? (
    <Spinner
      css={css`
        height: 80%;
        width: 80%;
      `}
      label="loading"
    />
  ) : (
    props.icon
  )
  return (
    <>
      {icon ? <IconSpan>{icon}</IconSpan> : null}
      {props.children ? (
        <StyledSpan>
          <LabelSpan>{props.children}</LabelSpan>
        </StyledSpan>
      ) : null}
    </>
  )
}
